// extracted by mini-css-extract-plugin
export var box = "_47-1";
export var checked = "_47-2";
export var descriptionSpacer = "_47-9";
export var disabled = "_47-3";
export var icon = "_47-6";
export var input = "_47-0";
export var labelSpacer = "_47-8";
export var medium = "_47-5";
export var small = "_47-4";
export var text = "_47-7";